class Configuration {
  BASEURL = process.env.REACT_APP_BASE_URL;
  imageBaseURL = process.env.REACT_APP_imageBaseURL;
}
export default Configuration;
